<script lang="ts" setup>
defineProps<{
  columns?: number;
}>();
</script>
<template>
  <dl
    class="description-list"
    :class="{ 'description-list--columns': columns }"
    :style="columns ? { columns, columnGap: '1rem' } : undefined"
  >
    <slot />
  </dl>
</template>
<style lang="scss" scoped>
dl {
  display: grid;

  &.description-list--columns {
    display: block;
  }
}
.description-list {
  @media (min-width: 768px) {
    margin-left: 0;
    margin-right: 0;
  }

  margin-left: var(--card-padding);
  margin-right: var(--card-padding);
}
</style>
